import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import TextField from "../../../Components/textField/textField";
import Api from "../../../services/api";
import TimeTextField from "../../../Components/timeTextField/TimeTextField";
import Alert from "../../../Components/alert/Alert";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";
import "./addWorkShift.css";
import { Checkbox } from "../../../Components/Checkbox/checkbox";
//mport { FaCalendar } from "react-icons/fa";
//import { FaRegCalendarAlt } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";
import { Checkboxcontainer } from "../../../Components/Checkboxcontainer/Chechboxcontainer";

export default class WorkShift extends React.Component {
  state = {
    description: null,
    start_time: null,
    end_time: null,
    show: false,
    message: "",
    reload: false,
    notification: false,
    notification_type: "success",
    notification_message: "",
    days: [false, false, false, false, false, false, false],
  };

  callBackCod = (value) => {
    this.setState({ description: value });
  };
  callBackHourInit = (value) => {
    this.setState({ start_time: value });
  };
  callBackHourFinal = (value) => {
    this.setState({ end_time: value });
  };

  callbackDay = (day) => {
    let daysWeek = this.state.days;
    if (daysWeek[day] === false) {
      daysWeek[day] = true;
    } else {
      daysWeek[day] = false;
    }

    this.setState({ days: daysWeek });
  };

  sendData = () => {
    if (
      this.state.description !== null &&
      this.state.description !== "" &&
      this.state.start_time !== null &&
      this.state.start_time !== "" &&
      this.state.end_time !== null &&
      this.state.end_time !== ""
    ) {
      let daysWeek = "";
      this.state.days[0] == true ? (daysWeek = daysWeek + "0,") : <></>;
      this.state.days[1] == true ? (daysWeek = daysWeek + "1,") : <></>;
      this.state.days[2] == true ? (daysWeek = daysWeek + "2,") : <></>;
      this.state.days[3] == true ? (daysWeek = daysWeek + "3,") : <></>;
      this.state.days[4] == true ? (daysWeek = daysWeek + "4,") : <></>;
      this.state.days[5] == true ? (daysWeek = daysWeek + "5,") : <></>;
      this.state.days[6] == true ? (daysWeek = daysWeek + "6,") : <></>;

      Api.post("/work-shifts/", {
        code: this.state.description,
        start_time: this.state.start_time,
        end_time: this.state.end_time,
        days: daysWeek,
      })
        .then((res) => {
          if (res.data.error !== undefined) {
            return alert(res.data.error);
          }
          this.setState({
            notification: true,
            notification_message: "Turno cadastrado com sucesso!",
          });
          setTimeout(() => {
            return window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          if (err.response.status === 400)
            this.setState({
              show: true,
              message: err.response.data.response,
              reload: true,
            });
        });
    } else {
      this.setState({
        show: true,
        message: "Necessário preencher todos os campos.",
      });
    }
  };

  callbackfunction = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      show,
      message,
      reload,
      notification,
      notification_message,
      notification_type,
    } = this.state;
    const daysWeek = [
      { id: "domingo", label: "Domingo", index: 0 },
      { id: "segunda", label: "Segunda", index: 1 },
      { id: "terca", label: "Terça", index: 2 },
      { id: "quarta", label: "Quarta", index: 3 },
      { id: "quinta", label: "Quinta", index: 4 },
      { id: "sexta", label: "Sexta", index: 5 },
      { id: "sabado", label: "Sábado", index: 6 },
    ];

    return (
      <div className="box">
        {notification == true ? (
          <>
            <Notification
              message={notification_message}
              type={notification_type}
            ></Notification>
            <Loading></Loading>
          </>
        ) : (
          <></>
        )}
        {show ? (
          <Alert
            show={show}
            message={message}
            parentCallback={this.callbackfunction}
            reload={reload}
          />
        ) : null}
        <div className="mot_del_reason form">
          <h4>Adicionar Turno</h4>
          <div className="inputs">
            <div className="select element">
              <TextField
                focus={true}
                title="Descrição do turno"
                max={20}
                validationType="varchar"
                parentCallback={this.callBackCod}
              />
            </div>
            <div className="element">
              <TimeTextField
                title="Hora de início"
                seconds
                parentCallback={this.callBackHourInit}
              ></TimeTextField>
            </div>
            <div className="element">
              <TimeTextField
                title="Hora de término"
                seconds
                parentCallback={this.callBackHourFinal}
              ></TimeTextField>
            </div>

            <Checkboxcontainer label="Dias da Semana" icon="calendar">
              {daysWeek.map(({ id, label, index }) => (
                <Col xs="6">
                  <Checkbox
                    key={id}
                    id={id}
                    label={label}
                    checked={this.state.days[index]}
                    setIsActive={() => {
                      const updatedDays = [...this.state.days];
                      updatedDays[index] = !updatedDays[index];
                      this.setState({ days: updatedDays });
                    }}
                  />
                </Col>
              ))}
            </Checkboxcontainer>
          </div>
          <div className="btnAddWorkShift submitButton">
            <Button
              className="btn-fixed"
              title="Adicionar"
              icon="add"
              parentCallback={this.sendData}
            />
          </div>
        </div>
      </div>
    );
  }
}
